import gql from 'graphql-tag'

export const fetchFreeBeersInfo = gql`
  query{
  getFreeBeerCount{
    count
    enabled
  }
}
`
